import { Component, Input } from '@angular/core';
import { DocViewerContextDoc } from '@models/ui/doc-viewer-context-doc.model';

@Component({
    selector: 'lex-doc-node',
    templateUrl: './doc-node.component.html',
    styleUrls: ['./doc-node.component.scss'],
    standalone: false
})
export class DocNodeComponent {

  @Input() node: DocViewerContextDoc;
  @Input() isSelected: boolean = false;
}
